export default function videoIcon() {
	const mediaTextBlocks = document.querySelectorAll('.wp-block-media-text');

  mediaTextBlocks.forEach(block => {
    const mediaContainer = block.querySelector('.wp-block-media-text__media');
    
    if (mediaContainer && mediaContainer.querySelector('video')) {
      mediaContainer.classList.add('icon');
    }
  });
}